import { ReactRenderer } from "./renderer";
class EmbeddedReactRenderer extends ReactRenderer {
    constructor(callback) {
        super();
        this._callback = callback;
    }
    schedule() {
        this.scheduled = true;
        queueMicrotask(() => {
            //        requestAnimationFrame(() => {
            //            console.log('[react] render start')
            this.scheduled = false;
            this.processing = true;
            let tasks = this.tasks;
            this.tasks = [];
            const markDirty = (html) => {
                var _a;
                html.dirty = true;
                (_a = html.children) === null || _a === void 0 ? void 0 : _a.forEach(c => markDirty(c));
            };
            //this.roots.forEach(root => markDirty(root as any))
            const rendered = this.roots.map(root => root.node.render(true));
            this._callback(rendered);
            //             this.roots.forEach((root, i) => {
            //                 ReactDOM.render(rendered[i], root.el, () => {
            // //                    console.log('[react] dom ready')
            //                     tasks
            //                         .filter(ownTaskFilter(this))
            //                         .filter(subscriptionTaskFilter(this.subscriptions))
            //                         .filter(unknownTaskFilter(this.subscriptions))
            //                     console.log('[react] render end', tasks.length)                    
            //                 })
            //             })
            this.processing = false;
        });
    }
}
export const createEmbedReactRenderer = (callback) => {
    return new EmbeddedReactRenderer(callback);
};
